/**
 * /welcome opens on the Join tab. A link that wants the Sign in tab instead
 * (the profile's signed-out banner) passes ?tab=signin; Login reads it once
 * on mount. Nothing else on /welcome reads the query string.
 */
export const LOGIN_TAB_PARAM = 'tab';
export const LOGIN_TAB_SIGN_IN = 'signin';
